import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import * as userLib from 'libs/userLib';
import * as userActions from 'modules/user';

import { AdminUserEditModal } from 'components';

class CtAdminUserAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      editModal: false
    };
  }

  mountEditModal = () => {
    const { editModal } = this.state;

    if (editModal) {
      // 열려진 경우로 닫는다.
      this.setState({ editModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ editModal: true });
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, editModal } = this.state;
    const { isAuth } = this.props;
    const { mountEditModal } = this;

    return (
      <div>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(formatMessage({ id: 'CtAdminUserAdd_1', defaultMessage: '등 록' }))}
          onClick={mountEditModal}
          color="blue"
        />
        {editModal && <AdminUserEditModal addMode isAuth={isAuth} mountEditModal={mountEditModal} />}
      </div>
    );
  }
}

CtAdminUserAdd.propTypes = {};
CtAdminUserAdd.defaultProps = {};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminUserAdd));



// WEBPACK FOOTER //
// ./src/script/containers/admin/user/CtAdminUserAdd.js